import { withPrefix } from "gatsby";
import React, { FunctionComponent, useContext, useState } from "react";
import { LoginButton } from "../components/buttons";
import { AuthLink, GatedLink } from "../components/links";
import { StyledNavbar } from "../components/styled";
import Context from "../context/Context";
import { useEventContext } from "../context/EventProvider";
import { useGatedLinkModalContext } from '../context/GatedLinkModalProvider';
import useEventDetails from "../hooks/useEventDetails";
import { CloseIcon, HamburgerIcon } from "./icons";

const Navbar: FunctionComponent = (props: any, { onToggle }) => {
  const { event } = useEventContext();
  const url = event?.url;
  const email = event?.email;
  const emailSubject = event?.emailSubject;
  const { setActiveModal } = useGatedLinkModalContext();
  const { virtual, eventEndTime } = useEventDetails();
  const [state, setState] = useState(false);
  const data = useContext(Context);
  const { navPagesDefault, navPagesSingle, socialShare, activeLink } = data;
  const navData = virtual ? navPagesSingle : navPagesDefault;

  const showHide = () => {
    onToggle && onToggle(!state);
    setState(!state);
  };
  const closeNav = () => {
    setState(false);
    onToggle && onToggle(false);
  };

  return (
    <StyledNavbar>
      <div className="toggleContainer">
        <div className="togBtn">
          <a
            onClick={showHide}
            className={`navTogglebtnOpen ${state ? "open" : "close"}`}
          >
            <CloseIcon />
          </a>
          <button
            onClick={showHide}
            className={`navTogglebtnClose ${state ? "close" : "open"}`}
          >
            <HamburgerIcon />
          </button>
        </div>
      </div>
      <div className={`pages ${state ? "open" : "close"}`}>
        {navData
            // .filter((page) => page.disabled !== true)
            .map((page, index: number) => {

              const isEventInThePast = eventEndTime < Date.now();
              // If showAfterEvent is undefined, null or false, we always show the link.
              // If showAfterEvent is true, we show the link if the event is in the past.
              const showLink =
                page.showAfterEvent === undefined ||
                page.showAfterEvent === null ||
                !page.showAfterEvent ||
                (page.showAfterEvent && isEventInThePast);

              if (!showLink) {
                return null;
              }

              const activeClass = activeLink === page.name ? "active-link" : "";
              if (page.disabled) {
                return (
                  <GatedLink
                    key={index}
                    to={page.path}
                    className={`page ${activeClass}`}
                    target={page.target}
                    closeNav={closeNav}
                  >
                    {page.name}
                  </GatedLink>
                );
              } else if (page.auth) {
                return (
                  <AuthLink
                    key={index}
                    to={page.path}
                    className={`page ${activeClass}`}
                    target={page.target}
                  >
                    {page.name}
                  </AuthLink>
                );
              } else if (
                page.path &&
                page.path.startsWith(("mailto", "mailto"))
              ) {
                return (
                  <a
                    key={index}
                    href={page.path}
                    target={page.target}
                    className={`page ${activeClass}`}
                    onClick={() => { setActiveModal(null); closeNav(); }}
                  >
                    {page.name}
                  </a>
                );
              } else {
                let path =
                  page.path && page.path.startsWith(("https", "https"))
                    ? page.path
                    : withPrefix(page.path);
                return (
                  <a
                    key={index}
                    href={path}
                    target={page.target}
                    className={`page ${activeClass}`}
                    onClick={() => { setActiveModal(null); closeNav(); }}
                  >
                    {page.name}
                  </a>
                );
              }
            })
            .filter(Boolean)}
        <LoginButton className="gdit-login-btn" closeNav={closeNav} />
        {socialShare.map((social, index: number) => (
          <a
            key={index}
            className="socialm"
            href={
              social.alt === "email"
                ? `${social.path}${email}?subject=${emailSubject}`
                : `${social.path}${url}`
            }
            target={"_blank"}
            onClick={() => { closeNav(); }}
          >
            <img src={withPrefix(social.img)} alt={social.alt} width="42px" />
          </a>
        ))}
      </div>
    </StyledNavbar>
  );
};

export default Navbar;
